import React from 'react'
import styled from 'styled-components'

import Container from '../../components/Container'
import Subscribe from '../../components/Subscribe/Subscribe'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Component = styled.div`
  padding: 4rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);
  display: flex;
  text-align: center;

  ${MEDIA_QUERY_DESKTOP} {
    padding: 8rem 0;
  }
`

const Title = styled.h1`
  margin-bottom: 2rem;
`

const Description = styled.div`
  opacity: .5;
  margin: 0 0 2rem 0;
`

const SubscribeSection = () => {
  return (
    <Component>
      <Container>
        <Title>
          Become part of a new creative economy
        </Title>
        <Description>
          Join the community on Discord and subscribe to our newsletter to receive the latest news.
        </Description>
        <Subscribe autoFocus={false} />
      </Container>
    </Component>
  )
}

export default SubscribeSection
